import { Injectable } from '@angular/core';

@Injectable()
export class DateTimeFormatting {

  constructor() {

  }

  get locales(): DateLocales {
    return {
      es: {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        dateFormat: 'dd/mm/yy'
      }
    };
  }

  get currentLocale() {
    return this.locales.es;
  } 
}

export interface DateLocales {
  es: DateLocale;
}

export interface DateLocale {
  firstDayOfWeek: number,
  dayNames: string[],
  dayNamesShort: string[],
  dayNamesMin: string[],
  monthNames: string[],
  monthNamesShort: string[],
  dateFormat: string
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/config/date-formatting.service.ts